import { Trans } from '@lingui/react/macro';
import { Text } from './Typography';

export function PanicBanner() {
  return (
    <>
      <div style={{ height: 60 }} />
      <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1001 }}>
        <div className="bg-panther bg-gradient-to-b from-panther to-destructive/50 flex justify-center items-center gap-4 p-2">
          <Text white l bold>
            <Trans>
              Our AI helpers are doing some quick maintenance. ProfAI will be back shortly.
            </Trans>
          </Text>
        </div>
      </div>
    </>
  );
}
